import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "row justify-end" };
const _hoisted_2 = { class: "row items-center q-mb-xs q-ml-xs" };
const _hoisted_3 = { class: "col" };
const _hoisted_4 = {
    key: 0,
    class: "fit"
};
const _hoisted_5 = {
    key: 1,
    class: "fit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_pdf_viewer = _resolveComponent("pdf-viewer");
    const _component_q_img = _resolveComponent("q-img");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createBlock(_component_q_dialog, {
        modelValue: _ctx.showDialog,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.showDialog) = $event)),
        class: "dlg--no-title dlg--open",
        persistent: ""
    }, {
        default: _withCtx(() => [
            _createVNode(_component_q_card, {
                class: "column full-height full-width",
                style: { "max-width": "80vw", "max-height": "100vh" }
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_q_btn, {
                            icon: "close",
                            flat: "",
                            round: "",
                            dense: "",
                            onClick: _ctx.closeDialog
                        }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.props.file ? _ctx.props.file.name : _ctx.fileName), 1)
                    ]),
                    _createVNode(_component_q_separator),
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.props.file)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_pdf_viewer, {
                                    pdfBlob: _ctx.props.file,
                                    class: "fit"
                                }, null, 8, ["pdfBlob"])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_ctx.FileHelper.isPDF(_ctx.fileName))
                                    ? (_openBlock(), _createBlock(_component_pdf_viewer, {
                                        key: 0,
                                        pdfBlob: _ctx.blob,
                                        class: "fit"
                                    }, null, 8, ["pdfBlob"]))
                                    : (_openBlock(), _createBlock(_component_q_img, {
                                        key: 1,
                                        src: _ctx.imageUrl,
                                        class: "fit",
                                        fit: "contain"
                                    }, null, 8, ["src"]))
                            ]))
                    ])
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue"]));
}
